import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { authenticationService } from '../../Services';

export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            const currentUser = authenticationService.currentUserValue;
            if (!currentUser) {                          
                const email = (props.match && props.match.params && props.match.params.recipientEmail && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(props.match.params.recipientEmail)) ? props.match.params.recipientEmail : "";
                return <Redirect to={{ pathname: "/login" + (email.length > 0 ? "/" + email : ""), state: { from: props.location } }} />
            }

            // authorised so return component
            return <Component {...props} />
        }} />)
}